/* eslint-disable no-unused-vars */
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import Swiper, { SwiperSlide } from "../../components/swiper";
import SectionTitleFive from "../../components/section-title/SectionTitleFive";
import ProductGridSingle from "../../components/product/ProductGridSingle";
import { getProducts } from "../../helpers/product";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    fetchProducts,
    fetchSuggestedProducts,
} from "../../store/slices/product-slice";
import ProductGridMain from "./ProductGridMain";

const RelatedProductSlider = ({ spaceBottomClass, productId }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { suggested_products } = useSelector((state) => state.product);
    const currency = useSelector((state) => state.currency);
    const { cartItems } = useSelector((state) => state.cart);
    const { wishlistItems } = useSelector((state) => state.wishlist);
    const { compareItems } = useSelector((state) => state.compare);

    useEffect(() => {
        if (productId) {
            dispatch(fetchSuggestedProducts({ product_id: productId }));
        }
    }, [productId]);

    return (
        /*<div className={clsx("related-product-area", spaceBottomClass)}>*/
        <div
            className={clsx(
                "product-area product-area--style2 bg-gray-3 pt-40",
                spaceBottomClass
            )}
        >
            {/* <div className="container">
                <SectionTitle
                    titleText={t("product__suggested_products")}
                    positionClass="text-center"
                    spaceClass="mb-50"
                />
                <ProductGridMain
                    category={"category"}
                    type="new"
                    limit={8}
                    spaceBottomClass="mb-25"
                    colorClass={"bg-gray-3"}
                    prods={suggested_products}
                />
            </div> */}
            <div className="container">
                <div className="product-tab-slider-wrapper position-relative">
                    <div className="product-top-bar mb-60">
                        <SectionTitleFive
                            titleText={t("product__suggested_products")}
                        />
                    </div>
                    <ProductGridMain
                        category={"category"}
                        type="new"
                        limit={8}
                        spaceBottomClass="mb-25"
                        colorClass={"bg-gray-3"}
                        prods={suggested_products}
                    />
                </div>
            </div>
        </div>
    );
};

RelatedProductSlider.propTypes = {
    product_id: PropTypes.string,
    spaceBottomClass: PropTypes.string,
};

export default RelatedProductSlider;
